/**
 * Ryan O'Dowd
 * 2022-03-22
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Platform,
} from 'react-native';

const getStyles = ({fonts, globalScale, colors}) => {
  return {
    lessonText: {
      display: Platform.OS === 'web' ? 'inline' : 'flex',
      paddingTop: globalScale * 8,
      paddingBottom: globalScale * 8,
      color: colors.white, // @TODO: dynamic for dark mode
      fontSize: globalScale * 18,
    },
    blankOptions: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexWrap: 'wrap',
      flexDirection: 'row',
      paddingTop: 8,
      paddingBottom: 8,
    },
    guessTextWrapper: {
      display: Platform.OS === 'web' ? 'inline' : 'flex',
      alignItems: 'flex-end',
      justifyContent: 'flex-end',
      marginBottom: Platform.OS === 'ios' ? -3 : 0, // @TODO: is this okay to do?
      padding: 0,
    },
    guessText: {
      display: Platform.OS === 'web' ? 'inline' : 'flex',
      color: colors.accentLight,
      fontFamily: fonts.primaryBold,
      marginBottom: globalScale * (Platform.OS === 'web' ? -5 : -4), // @TODO: is this okay to do?
      fontSize: globalScale * 18,
      // @TODO: textDecorationLine: 'underline',
    },
    wrongGuessText: {
      color: colors.alert,
    },
    option: {
      padding: globalScale * 8,
      backgroundColor: colors.accent,
      borderRadius: globalScale * 12, // @TODO: should probably match submit buttons
      margin: globalScale * 4,
    },
    hidden: {
      opacity: 0,
    },
    optionText: {
      color: colors.primaryExtraDark,
      fontSize: globalScale * 16,
    },
    correctAnswer: { // @TODO: make sure this can't run into question/options on smaller screens and larger text
      position: 'absolute',
      bottom: 0,
      padding: globalScale * 8,
      marginBottom: 16,
    },
    correctAnswerText: {
      display: Platform.OS === 'web' ? 'inline' : 'flex',
      color: colors.white,
      fontSize: globalScale * 18,
    },
    correctedWrongGuess: {
      color: colors.accentLight,
      fontFamily: fonts.primaryBold,
    },
  };
};

export default getStyles;
